/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-script-url */
/* eslint-disable react/jsx-max-props-per-line */
import PropTypes from 'prop-types';
import React from 'react';
import DivContainer from '../components/DivContainer';

export const MenuItemIconCardType = (props) => {
    const {alt, className, iconSvg, id, handleClick, png, headerText, contentText} = props;

    return <DivContainer colClass='col-xxl-6 col-xl-6 col-lg-10 col-md-12 col-sm-12 el-border'>
   
    <div id={id} className={className} onClick={handleClick}>
        <DivContainer colClass='col-md-5' className= 'textcol5'>
        <img className={'card-img-class'} alt={alt} src={png? `/images/${iconSvg}.png` : `/images/${iconSvg}.svg`}  />
            </DivContainer>
            <DivContainer colClass='col-md-7' className='textcol7'>
            <div className='card-type-icon-header'>{headerText}</div>
            <div className='card-type-icon-content-text'>{contentText}</div>
            </DivContainer>
            </div>
    </DivContainer>
    
};

MenuItemIconCardType.defaultProps = {
    className:'row content-of-icon'
};

MenuItemIconCardType.propTypes = {
    id: PropTypes.string,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    iconSvg: PropTypes.string.isRequired,
    handleClick: PropTypes.func,
    eventListeners: PropTypes.array,
    png: PropTypes.string,
    headerText: PropTypes.string,
    contentText: PropTypes.string,
    elementData: PropTypes.array,

};

export default MenuItemIconCardType;
